import {
  configure,
  extend,
  setInteractionMode,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import {
  email,
  min_value,
  required,
  max,
  dimensions,
  length,
  numeric,
} from "vee-validate/dist/rules";
import i18n from "@/plugins/I18n";
import { documentFormats } from "@/utils/constants";

configure({
  defaultMessage: (field, values) => {
    return i18n.t(`validation.${values._rule_}`, values).toString();
  },
});
extend("dimensions", dimensions);
extend("length", length);
extend("numeric", numeric);

extend("max", max);

extend("email", email);
extend("required", required);
extend("min_value", {
  params: min_value.params,
  validate(val, { min }) {
    if (typeof val === "number") return true;
    if (typeof val === "string") {
      val = val.trim();
      val = parseInt(val);
      return Number.isNaN(val) ? false : val >= min;
    }
    return false;
  },
});

extend("required_custom_message", {
  params: ["target"],
  computesRequired: true,
  validate(value) {
    if (typeof value === "string") {
      return value.trim() !== "";
    } else {
      return !!value;
    }
  },
  message(_, { target }) {
    return target;
  },
});

function less_than(val, { max }) {
  if (typeof val === "string") {
    val = val.replace(/\s/g, "");
    val = +val;
    return val < max;
  }
  return false;
}
extend("less_than", {
  params: ["max"],
  validate: less_than,
});

function maxRule(val, { max }) {
  if (typeof val === "number") return true;
  if (typeof val === "string") {
    val = val.replace(/\s/g, "");
    val = val.replace(/,/g, ".");
    val = +val;
    return Number.isNaN(val) ? false : val <= max;
  }
  return false;
}

extend("max_given_value", {
  params: ["max"],
  validate: maxRule,
});
extend("phone", {
  validate(value) {
    const phoneRegex = /\(?\d{2}\)?-?\d{3}(-?\d{2}){2}/;
    return phoneRegex.test(value);
  },
});
extend("confirmed", {
  params: ["value", "fieldName"],
  validate(value, { value: fieldValue }) {
    return value === fieldValue;
  },
});
extend("document", {
  validate(value) {
    if (value) {
      if (Array.isArray(value)) {
        return value.every((item) => documentFormats.includes(item.type));
      }
      if (value.type) {
        return documentFormats.includes(value.type);
      }
    }
    return true;
  },
});

extend("not_empty_file", {
  validate(value) {
    if (value) {
      return value.size > 0;
    }
    return true;
  },
});

extend("max_value", {
  params: ["max"],
  validate: maxRule,
});

setInteractionMode("custom", ({ errors }) => {
  if (errors.length) {
    return { on: ["input"] };
  }
  return { on: ["submit"] };
});

export default {
  install(Vue) {
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
  },
};
